import {Routes} from '@angular/router';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PersonalComponent} from './personal/personal.component';
import {AbsencesComponent} from './absences/absences.component';
import {RequestsComponent} from './requests/requests.component';
import {EditComponent as AbsenceRequestEditComponent} from './edit/edit.component';
import {
  TimeTrackingAbsenceRequestService
} from '../../../services/api/time-tracking/time-tracking-absence-request.service';
import {Backend} from '@generated-backend-types';
import RoleEnum = Backend.App.Enums.Auth.RoleEnum;

export const routes: Routes = [
  {
    path: 'personal',
    children: [
      {
        path: '',
        component: PersonalComponent,
        canActivate: [canActivateGuard],
        data: {
          allRolesNeeded: [RoleEnum.TIME_TRACKING_EMPLOYEE],
          breadcrumb: [
            {
              label: 'authenticated.time_tracking.absence_requests.personal.breadcrumb',
              translate: true,
              route: '/time-tracking/absence-requests/personal',
            },
          ]
        }
      },
      {
        path: 'add',
        component: AbsenceRequestEditComponent,
        canActivate: [canActivateGuard],
        data: {
          allRolesNeeded: [RoleEnum.TIME_TRACKING_EMPLOYEE],
          breadcrumb: [
            {
              label: 'authenticated.time_tracking.absence_requests.personal.breadcrumb',
              translate: true,
              route: '/time-tracking/absence-requests/personal',
            },
            {label: 'authenticated.time_tracking.absence_requests.create.breadcrumb', translate: true,},
          ]
        }
      },
      {
        path: ':id',
        component: AbsenceRequestEditComponent,
        canActivate: [canActivateGuard],
        resolve: {
          absenceRequest: TimeTrackingAbsenceRequestService,
        },
        data: {
          allRolesNeeded: [RoleEnum.TIME_TRACKING_EMPLOYEE],
          breadcrumb: [
            {
              label: 'authenticated.time_tracking.absence_requests.personal.breadcrumb',
              translate: true,
              route: '/time-tracking/absence-requests/personal',
            },
            {dynamic: true, dataKey: 'absenceRequest.start_at,-,absenceRequest.start_at', route: '/time-tracking/absence-requests/personal/:id'},
            {label: 'authenticated.time_tracking.absence_requests.edit.breadcrumb', translate: true,},
          ]
        }
      },
    ]
  },
  {
    path: 'absences',
    children: [
      {
        path: '',
        component: AbsencesComponent,
        canActivate: [canActivateGuard],
        data: {
          anyRoleNeeded: [RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD],
          breadcrumb: [
            {
              label: 'authenticated.time_tracking.absence_requests.absences.breadcrumb',
              translate: true,
              route: '/time-tracking/absence-requests/absences',
            },
          ]
        }
      },
      {
        path: ':id',
        component: AbsenceRequestEditComponent,
        canActivate: [canActivateGuard],
        resolve: {
          absenceRequest: TimeTrackingAbsenceRequestService,
        },
        data: {
          showTimeTrackingEmployee: true,
          anyRoleNeeded: [RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD],
          breadcrumb: [
            {
              label: 'authenticated.time_tracking.absence_requests.absences.breadcrumb',
              translate: true,
              route: '/time-tracking/absence-requests/absences',
            },
            {dynamic: true, dataKey: 'absenceRequest.time_tracking_employee.user.name,|,absenceRequest.start_at,-,absenceRequest.start_at', route: '/time-tracking/absence-requests/absences/:id'},
            {label: 'authenticated.time_tracking.absence_requests.edit.breadcrumb', translate: true,},
          ]
        }
      },
    ]
  },
  {
    path: 'requests',
    children: [
      {
        path: '',
        component: RequestsComponent,
        canActivate: [canActivateGuard],
        data: {
          anyRoleNeeded: [RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD],
          breadcrumb: [
            {
              label: 'authenticated.time_tracking.absence_requests.requests.breadcrumb',
              translate: true,
              route: '/time-tracking/absence-requests/requests',
            },
          ]
        }
      },
      {
        path: ':id',
        component: AbsenceRequestEditComponent,
        canActivate: [canActivateGuard],
        resolve: {
          absenceRequest: TimeTrackingAbsenceRequestService,
        },
        data: {
          showTimeTrackingEmployee: true,
          anyRoleNeeded: [RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD],
          breadcrumb: [
            {
              label: 'authenticated.time_tracking.absence_requests.requests.breadcrumb',
              translate: true,
              route: '/time-tracking/absence-requests/requests',
            },
            {dynamic: true, dataKey: 'absenceRequest.time_tracking_employee.user.name,|,absenceRequest.start_at,-,absenceRequest.start_at', route: '/time-tracking/absence-requests/requests/:id'},
            {label: 'authenticated.time_tracking.absence_requests.edit.breadcrumb', translate: true,},
          ]
        }
      },
    ]
  }
];
